
import { Language } from './types';

export const translations = {
  en: {
    rocketName: "WonderVerse",
    tagline: "Cognitive OS",
    parents: "Parents",
    focus: "Focus",
    dailyStation: "Energy Core",
    dailyDesc: "Complete homework to recharge.",
    startFocus: "Start Focus",
    academy: "Star Academy",
    academyDesc: "Explore the infinite knowledge tree.",
    progress: "Progress",
    level: "Level",
    chatPlaceholder: "Ask Nono...",
    thinking: "Thinking...",
    generating: "Generating...",
    generatingPath: "Generating new path...",
    expand: "Expand Curriculum",
    completePrev: "Complete previous nodes to expand",
    start: "START",
    cancel: "Exit",
    completeMission: "Complete Mission",
    next: "Next Step",
    prev: "Go Back",
    listen: "Listen",
    comic: "Comic Strip",
    quiz: "Mission Quiz",
    growthDashboard: "Growth Dashboard",
    cognitiveRadar: "Cognitive Radar",
    aiInsight: "AI Insight Report",
    genReport: "Generate Report",
    focusTime: "Focus Time",
    tasksDone: "Tasks Done",
    skillsUnlocked: "Skills Unlocked",
    energyStation: "Energy Station",
    focusPrompt: "How long do you need to focus?",
    pause: "Pause",
    resume: "Resume",
    abort: "Give Up",
    // Auth & Onboarding
    login: "Login",
    signup: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Explorer Name",
    welcomeBack: "Welcome Back, Commander",
    joinAdventure: "Join the Adventure",
    haveAccount: "Already have an account?",
    noAccount: "No account yet?",
    logout: "Log Out",
    authError: "Authentication failed. Check environment variables (VITE_ prefix).",
    selectGrade: "Select Your Grade",
    startJourney: "Launch Mission",
    // SaaS Pro
    proFeature: "PRO Feature",
    upgradeNow: "Upgrade to Pro",
    proBenefits: ["200 Energy Cap", "Advanced AI Insights", "Stage 3+ Evolutions", "HD Visuals"],
    price: "$9.9/month",
    currentPlan: "Current Plan: Explorer",
    // Dashboard
    growthProjection: "Growth Trajectory",
    subjectDetails: "Subject Distribution Details",
    current: "Current",
    threeMonths: "3 Months",
    oneYear: "1 Year",
    threeYears: "3 Years",
    allSubjects: "Overall",
    analyzing: "AI Analyzing...",
    cognitiveStage: "Current Cognitive Stage",
    keyFocus: "Key Focus",
    subjects: {
      math: "Math",
      chinese: "Chinese",
      english: "English",
      science: "Science",
      history: "History",
      art: "Art"
    },
    // New Free Adventure
    warpDrive: "Warp Drive",
    warpDesc: "Enter any topic to generate a custom adventure.",
    warpPlaceholder: "I want to learn: Black Holes, Poetry, Photosynthesis...",
    launch: "WARP",
    quickTasks: "Missions",
    addTask: "Add Task",
    // Focus New
    setTimer: "Set Timer",
    estReward: "Est. Energy",
    minutes: "min",
    focusing: "Focusing...",
    goodJob: "Mission Complete!",
    focusFail: "Mission Aborted",
    // Fixes & Additions
    preparing: "Nono is preparing your adventure about",
    adapting: "Adapting content to Grade",
    logic: "Logic",
    currentMission: "Current Mission",
    viewReports: "View Reports",
    pilotMode: "Pilot Mode Active",
    warpEncrypted: "Warp Channel Encrypted",
    personalize: "Personalize your cognitive adventure.",
    lowEnergy: "Low Energy Warning",
    addHomework: "Add homework to recharge",
    energyRecharged: "Energy Recharged",
    claimReward: "Claim Reward",
    projectionDisclaimer: "Structure-Based Projection • Not a Promise",
    lvl: "Lvl",
    startBtn: "Start",
    // Profile
    age: "Age",
    grade: "Grade",
    interests: "Interests (Select max 5)",
    saveProfile: "Save ID Card",
    saving: "Saving...",
    // Onboarding Wizard
    obStep1: "Identity Setup",
    obStep1Desc: "Choose your pilot avatar.",
    obStep2: "Calibration",
    obStep2Desc: "Syncing cognitive levels.",
    obStep3: "Interests",
    obStep3Desc: "Injecting personality data.",
    obComplete: "System Ready",
    obCompleteDesc: "Welcome to WonderVerse.",
    selectAvatar: "Select Avatar",
    pickInterests: "What do you love?",
    // New Widget Strings
    solveProblem: "Solve",
    speak: "Speak",
    didYouKnow: "Did You Know",
    // Home Redesign
    exploreUniverse: "Explore the Unknown\nKnowledge Universe",
    continueJourney: "Continue Your Journey",
    recForYou: "Recommended For You",
    missionBoard: "Mission Board",
    energyTasks: "Complete tasks to recharge energy",
    allSubjectsBtn: "All Subjects",
  },
  zh: {
    rocketName: "奇想星图",
    tagline: "认知操作系统",
    parents: "家长中心",
    focus: "专注",
    dailyStation: "能量核心",
    dailyDesc: "完成作业补充能量。",
    startFocus: "开始专注",
    academy: "星际学院",
    academyDesc: "探索无限知识树。",
    progress: "进度",
    level: "等级",
    chatPlaceholder: "问问诺诺...",
    thinking: "思考中...",
    generating: "生成中...",
    generatingPath: "正在生成新路径...",
    expand: "扩展课程",
    completePrev: "完成前置课程以解锁",
    start: "开始",
    cancel: "退出",
    completeMission: "完成任务",
    next: "下一步",
    prev: "上一步",
    listen: "听诺诺说",
    comic: "趣味漫画",
    quiz: "挑战问答",
    growthDashboard: "成长档案",
    cognitiveRadar: "认知雷达",
    aiInsight: "AI 深度洞察",
    genReport: "生成报告",
    focusTime: "专注时长",
    tasksDone: "任务完成",
    skillsUnlocked: "技能解锁",
    energyStation: "能量补给站",
    focusPrompt: "你需要专注多久来完成作业？",
    pause: "暂停",
    resume: "继续",
    abort: "放弃任务",
    // Auth & Onboarding
    login: "登录",
    signup: "注册",
    email: "邮箱",
    password: "密码",
    name: "指挥官昵称",
    welcomeBack: "欢迎回来，指挥官",
    joinAdventure: "加入星际探险",
    haveAccount: "已有账号？",
    noAccount: "还没有账号？",
    logout: "退出登录",
    authError: "认证失败。请检查环境变量配置（需 VITE_ 前缀）。",
    selectGrade: "请选择你的年级",
    startJourney: "启动任务",
    // SaaS Pro
    proFeature: "PRO 专属功能",
    upgradeNow: "升级至专业版",
    proBenefits: ["200 能量上限", "AI 深度成长报告", "解锁 3 阶段以上进化", "超高清 AI 绘图"],
    price: "￥68/月",
    currentPlan: "当前方案: 初级探索者",
    // Dashboard
    growthProjection: "成长轨迹推演",
    subjectDetails: "学科分布详情",
    current: "当前",
    threeMonths: "3个月后",
    oneYear: "1年后",
    threeYears: "3年后",
    allSubjects: "全科总览",
    analyzing: "AI 推演中...",
    cognitiveStage: "当前认知阶段",
    keyFocus: "重点关注",
    subjects: {
      math: "数学",
      chinese: "语文",
      english: "英语",
      science: "科学",
      history: "历史",
      art: "艺术"
    },
    // New Free Adventure
    warpDrive: "自由探索 (Warp Drive)",
    warpDesc: "输入任何感兴趣的话题，生成定制冒险。",
    warpPlaceholder: "我想学：黑洞、唐诗、光合作用...",
    launch: "开启冒险",
    quickTasks: "补给任务",
    addTask: "添加任务",
    // Focus New
    setTimer: "设定时长",
    estReward: "预计能量",
    minutes: "分钟",
    focusing: "专注中...",
    goodJob: "专注完成！",
    focusFail: "专注中断",
    // Fixes & Additions
    preparing: "诺诺正在为你准备冒险：",
    adapting: "正在适配年级",
    logic: "逻辑力",
    currentMission: "当前任务",
    viewReports: "查看详细报告",
    pilotMode: "领航模式已激活",
    warpEncrypted: "星际频道已加密",
    personalize: "定制你的认知探险旅程。",
    lowEnergy: "能量不足警告",
    addHomework: "添加作业以补充能量",
    energyRecharged: "能量已充满",
    claimReward: "领取奖励",
    projectionDisclaimer: "基于认知结构的推演 • 仅供参考",
    lvl: "Lv.",
    startBtn: "启动",
    // Profile
    age: "年龄",
    grade: "年级",
    interests: "兴趣爱好 (最多选5个)",
    saveProfile: "保存指挥官证件",
    saving: "保存中...",
    // Onboarding Wizard
    obStep1: "身份建立",
    obStep1Desc: "选择你的指挥官形象",
    obStep2: "认知校准",
    obStep2Desc: "同步年级与年龄数据",
    obStep3: "兴趣注入",
    obStep3Desc: "让 AI 了解你的喜好",
    obComplete: "系统就绪",
    obCompleteDesc: "欢迎来到 WonderVerse",
    selectAvatar: "选择头像",
    pickInterests: "你喜欢什么？",
    // New Widget Strings
    solveProblem: "逻辑解谜",
    speak: "跟读挑战",
    didYouKnow: "你知道吗",
    // Home Redesign
    exploreUniverse: "探索未知的\n知识宇宙",
    continueJourney: "继续你的旅程",
    recForYou: "为你推荐",
    missionBoard: "任务面板",
    energyTasks: "完成任务以补充能量",
    allSubjectsBtn: "全部学科",
  }
};
